import React, { useMemo } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

// 🔥 helper
const getCssVar = (variable: string) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
};

const StatusPieChart = ({ data }: any) => {
  const chartData = useMemo(
    () => [
      {
        name: "Revenue",
        value: data?.revenue || 0,
        color: getCssVar("--success"),
      },
      {
        name: "Tickets",
        value: data?.tickets || 0,
        color: getCssVar("--warning"),
      },
    ],
    [data]
  );

  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey="value"
          innerRadius={60}
          outerRadius={90}
          paddingAngle={3}
          label
        >
          {chartData.map((entry, index) => (
            <Cell key={index} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default StatusPieChart;